import React, { useEffect, useState } from 'react';
import Navbar from './components/Navbar';
import Home from './components/Home';
import About from './components/About';
import Skills from './components/Skills';
import Work from './components/Work';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  const [orientation, setOrientation] = useState('');
  const [isMobile, setIsMobile] = useState(false);
  const [showRotateMessage, setShowRotateMessage] = useState(false);

  useEffect(() => {
    const handleOrientationChange = () => {
      const angle = window.orientation || window.screen.orientation.angle;
      if (angle === 0 || angle === 180) {
        // Portrait orientation
        setOrientation('portrait');
        setShowRotateMessage(false); // Reset the message when orientation changes to portrait
      } else {
        // Landscape orientation
        setOrientation('landscape');
        if (isMobile) {
          setShowRotateMessage(true); // Show the message if orientation changes to landscape and the device is a mobile
        }
      }
    };

    // Listen for the orientation change event
    window.addEventListener('orientationchange', handleOrientationChange);

    // Initial orientation check
    handleOrientationChange();

    // Check if the user is on a mobile device
    setIsMobile(/Mobi|Android/i.test(navigator.userAgent));

    // Clean up the event listener
    return () => {
      window.removeEventListener('orientationchange', handleOrientationChange);
    };
  }, [isMobile]);

  return (
    <div>
      <Navbar />
      {!showRotateMessage && (
        <>
          <Home />
          <Skills />
          <Work />
          <About />
          <Contact />
          <Footer />
        </>
      )}
      {showRotateMessage && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          color: '#fff',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 9999,
        }}>
          <p>Please rotate your device back to portrait mode.</p>
        </div>
      )}
    </div>
  );
}

export default App;
